'use strict';

angular.module('mobile-apps')
	.directive('spreadsheetColumnSelect',['EntryMain', 'AvailableLanguages', 'Utilities', function(EntryMain, AvailableLanguages, Utilities) {
		return {
			scope:
			{
				fileContent : '=',
				// ========================================
				// IMPORTANT !
				// ========================================
				// selectedData needs the look like this
				// on in the controller which uses directive
				// var selectedData = {
				// 	columnTypes: [],
				// 	dataComplete: false,
				// 	includeFirstRow: false
				// }
				selectedData : '='
			},
			replace: true,
			templateUrl: 'modules/mobile-apps/views/spreadsheet-column-select.client.view.html',
			link: function (scope, elem, attrs) {

				scope.data = {
					fileContent: scope.fileContent,
					requiresKey: scope.$parent.data.requiresKey,
					anyMetadata: scope.$parent.data.metadata && scope.$parent.data.metadata.length,
					columnOptions: [
						{
							id: 'KEY',
							name: 'String Identifier',
							type: 'key',
							group: 'Existing Metadata'
						},
						{
							id: 'LENGTH',
							name: 'String Length',
							type: 'key',
							group: 'Existing Metadata'
						},
						{
							id: 'DESCRIPTION',
							name: 'Description',
							type: 'key',
							group: 'Existing Metadata'
						}
					],
					groups: [
						'Existing Metadata',
						'Additional Metadata',
						'Languages'
					]
				};

				scope.data.columnOptions = scope.data.columnOptions.concat(scope.$parent.data.metadata.map(function(item){
					return ({
						id: 'METADATA_' + item.fieldName,
						name: item.fieldName,
						type: 'key',
						group: 'Additional Metadata'
					});
				}));

				/**
				 * Inits the data like the langugage select fields
				 */
				function init() {
					AvailableLanguages.get().$promise.then(
						function(availableLanguages) {
							var languageData;
							for (var languageId in EntryMain.languages) {
								languageData = EntryMain.languages[languageId];
								scope.data.columnOptions.push({
									id: languageData.name,
									name: availableLanguages[languageData.name],
									type: 'language',
									group: 'Languages'
								});
							}
						}
					)
					.catch(
						function(error) {
							Utilities.showMessageErrorResponse(error);
						}
					);
				}


				/**
				 * Callback whenever the type of a column changes. Make sure that a type
				 * does not get selected twice and that the "continue" button gets
				 * activated as soon as all required types got selected.
				 */
				scope.columnTypeChanged = function(columnIndex, sheetName) {
					// Make sure that no option is selected twice
					scope.selectedData.sheetName = sheetName;
					var newType = scope.selectedData.columnTypes[columnIndex];
					var i;
					if (newType !== '') {
						for (i=0;i<scope.selectedData.columnTypes.length;i++) {
							if (i === columnIndex) {
								// Is the column which just got changed. So skip
								// the check because we want to keep its value.
								continue;
							}
							if (scope.selectedData.columnTypes[i] === newType) {
								// Another column already has the same type than
								// the one which got changed. So reset it to
								// nothing selected.
								scope.selectedData.columnTypes[i] = '';
							}
						}
					}

					// Check if at least one language got selected
					scope.selectedData.dataComplete = false;
					var columnValue, hasKey, hasLanguage;
					for (i=0;i<scope.selectedData.columnTypes.length;i++) {
						columnValue = scope.selectedData.columnTypes[i];
						if (columnValue) {
							if (columnValue !== 'KEY') {
								hasLanguage = true;
							} else {
								hasKey = true;
							}
						}
						if ((hasKey || !scope.data.requiresKey) && hasLanguage) {
							scope.selectedData.dataComplete = true;
						}
					}
				};


				init();
			}
		};
	}]);
